// extracted by mini-css-extract-plugin
export default {"socialBlock":"Md8xi","iconMenuList":"vRutB","iconItemLink":"TaYje"};